// REMINDER: Adding a new value?  Don't forget to add it to STREAM_TYPE_NIBBLE, too.
// REMINDER: Adding a new value?  Don't forget to update AGORA_PUBLISHER_STREAM_TYPE

export default {
  GUEST: 'guest',
  HOST_CAMERA: 'hostCamera',
  HOST_MERGED: 'hostMerged',
  HOST_SUBSCRIBER: 'hostSubscriber',
  MOBILE: 'mobile',
  RTMP: 'rtmp',
  SCREEN: 'screen',
  SLIDE: 'slide',
  ISO_MOBILE: 'iso-mobile',
  ISO_SCREEN: 'iso-screen',
  ISO_GUEST: 'iso-guest',
  COMPOSER: 'composer',
};
